export const AppRoutesEnum = {
  Home: '/',
  Chest: '/chest',
  Points: '/points',
  Referral: '/referral',
  Rewards: '/rewards',
  MyNFT: '/my-nft',
  NFTGallery: '/nft-gallery',
  PreLaunch: '/pre-launch',
  Wrapped: '/wrapped',
  HolidayCampaign: '/holiday',
  NewYearCampaign: '/new-year-campaign',
  License: '/license',
  Privacy: '/privacy',
  Copyright: '/copyright',
};

export const BACKEND_SUCCESS_CODE = 0;

export const REFERRAL_CONSTANTS = {
  PENDING_CODE_KEY: 'junk_fun_pending_referral',
  CODE_LENGTH: 5,
  CODE_PATTERN: /^[A-Z0-9]{5}$/,
};

/**
 * Dust swapping constants for converting low-value tokens to SOL via Jupiter
 */
export const DUST_SWAP_CONSTANTS = {
  /** Minimum SOL value for a token to be eligible for dust swapping */
  MIN_SWAP_VALUE_SOL: 0.002,
  /** Minimum value in lamports (0.002 SOL = 2,000,000 lamports) */
  MIN_SWAP_VALUE_LAMPORTS: 2_000_000,
  /** Platform fee percentage (10%) */
  PLATFORM_FEE_PERCENT: 10,
  /** Points multiplier for dust swapping rewards */
  POINTS_MULTIPLIER: 500_000,
  /** Points divisor (2.5% = 0.025) */
  POINTS_DIVISOR: 0.025,
};
